import { render, staticRenderFns } from "./account_setup.vue?vue&type=template&id=572bbd42&"
import script from "./account_setup.vue?vue&type=script&lang=js&"
export * from "./account_setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('572bbd42')) {
      api.createRecord('572bbd42', component.options)
    } else {
      api.reload('572bbd42', component.options)
    }
    module.hot.accept("./account_setup.vue?vue&type=template&id=572bbd42&", function () {
      api.rerender('572bbd42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/login/account_setup.vue"
export default component.exports